<template>
  <div
    class="career-job-position-header-wrapper"
    data-test-id="component-career-job-position-header"
  >
    <div class="container">
      <div class="flex flex-wrap  -mx-tiny">
        <div class="back-button block w-full lg:w-1/6 px-standart pb-micro border-0 no-underline">
          <span
            v-show="hasHistoryBack()"
            href="#"
            :class="[
              'flex items-center justify-center',
              'btn rounded-full',
              'w-medium h-medium',
              'p-0',
              'cursor-pointer',
              'hover:bg-dusty-gray'
            ]"
            data-test-id="button-career-job-position-back"
            @click="$router.go(-1)"
          ><MajorityUiMajorityIcon icon="chevron-left" class="icon flex justify-center" /></span>
        </div>
        <div
          class="career-printable-content block w-full lg:w-5/6 px-standart"
          data-test-id="block-career-job-position-content"
        >
          <h1
            class="h1 title mb-standart"
            data-test-id="text-career-job-position-title"
          >
            {{ job.title }}
          </h1>
          <div class="flex flex-wrap">
            <div class="block w-1/2 md:w-1/4 pr-standart break-words">
              <p class="h3 department mb-standart">
                {{ $messages('about.career.department') }}
              </p>
            </div>
            <div class="block w-1/2 md:w-3/4 break-words">
              <p
                class="h3 department mb-standart"
                data-test-id="text-career-job-position-department"
              >
                {{ job.department }}
              </p>
            </div>
          </div>
          <div class="flex flex-wrap">
            <div class="block w-1/2 md:w-1/4 pr-standart break-words">
              <p class="h3 location mb-standart">
                {{ $messages('about.career.location') }}
              </p>
            </div>
            <div class="block w-1/2 md:w-3/4 break-words">
              <p
                class="h3 location mb-standart"
                data-test-id="text-career-job-position-location"
              >
                {{ job.city }}
              </p>
            </div>
          </div>
        </div>

        <div class="block w-full lg:w-5/6 lg:ml-auto px-standart">
          <MajorityUiMajorityLink
            v-if="showApplyButton"
            :to="$mRouter.getLocalRoute({name: 'company-career-apply', query: {gh_jid: jobId}})"
            class="btn"
            data-test-id="button-career-job-position-apply"
            no-tracking
          >
            {{ $messages('about.career.apply_now') }}
          </MajorityUiMajorityLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup () {
    const jobsApi = useJobs()
    return {
      jobsApi
    }
  },
  props: {
    showApplyButton: {
      type: Boolean,
      default: () => false
    },
    jobId: {
      type: Number,
      default: () => true
    }
  },
  async mounted () {
    this.isLoading = true
    this.job = await this.jobsApi.getJobDetails(this.jobId);
    this.isLoading = false
  },
  data () {
    return {
      allLocation: this.$messages('about.career.job_location_all'),
      prevRoute: null,
      job: {

      }
    }
  },
  computed: {

  },
  methods: {
    hasHistoryBack () {
      if (process.client) {
        return window.history.length > 1
      }
      return false
    }
  }
}
</script>
